<div class="space-y-16">
    <h2 class="tracking-wide">Where you'll stay</h2>
    <div class="grid grid-cols-1 gap-8 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
        @for (accommodation of accommodations; track accommodation.sys.id) {
            <div>
                <app-trips-itinerary-accommodation-item
                    [accommodation]="
                        accommodation
                    "></app-trips-itinerary-accommodation-item>
            </div>
        }
    </div>
</div>
